import apiFetch from '../apiFetch'

export default function (idTipoDiluyente, token) {
  return apiFetch({endPoint: `TipoDiluyente/cambiarTipoDiluyentePredeterminado`, method: 'POST', body: {idTipoDiluyente}, token: token})
}